import { Project } from '../types';

export const projects: Project[] = [
  {
    id: 'commercial-breaker',
    name: 'CommercialBreaker & Toonami Tools',
    tagline: 'Because your anime deserves commercial breaks',
    description: 'Put commercials back into commercial-free programming. Yes, really.',
    longDescription: [
      'Yeah, we\'re those idiots who put commercials back into commercial-free programming. What are you gonna do about it?',
      'Born from Toonami nostalgia and two years of coding in the mines, CommercialBreaker creates an authentic Toonami experience complete with bumps, transitions, and yes, commercial breaks.',
      'Features three Python apps, a web interface called "Absolution", a desktop GUI called "TOM", and our own streaming server "ComBreakDirect" - because sometimes you just want to cut out the middleman.',
      'Works with Plex, Jellyfin, DizqueTV, and Tunarr. Or just use our streaming server and do it all yourself.'
    ],
    featured: true,
    link: '/commercial-breaker',
    githubLink: 'https://github.com/theweebcoders/CommercialBreaker',
    dockerLink: 'https://hub.docker.com/r/tim000x3/commercial-breaker',
    demoLink: undefined,
    technologies: ['Python', 'Flask', 'FFmpeg', 'SQLite', 'Tkinter'],
    status: 'active'
  },
  {
    id: 'dizquetv-fork',
    name: 'DizqueTV (Our Fork)',
    tagline: 'Modified for cutless mode support',
    description: 'Because Commercial Breaker needed it to work properly.',
    longDescription: [
      'We forked DizqueTV to add support for "cutless mode" - a way to simulate commercial breaks without actually cutting your video files.',
      'This saves disk space, preserves your originals, and makes the whole process much faster.',
      'Are we ashamed? No. We\'re efficient.'
    ],
    featured: false,
    link: 'https://github.com/theweebcoders/dizquetv',
    githubLink: 'https://github.com/theweebcoders/dizquetv',
    technologies: ['JavaScript', 'Node.js', 'FFmpeg'],
    status: 'maintenance'
  }
];

/**
 * Future projects section (the "Probably Never Happening" list)
 */
export const futureProjects = [
  'World domination',
  'A dating app for weebs (because apparently we need more ways to be socially awkward)',
  'Skynet, but it only recommends anime',
  'A program that automatically adds "believe it" to every sentence',
  'Commercials for things that don\'t need commercials',
  'A blockchain... just kidding, we\'re not monsters',
  '???',
  'Profit (also probably never happening)'
];
